<template>
<div class="s4s-page">
  <div class="s4s-user">
    <div class="s4s-user-header">
      {{userInfo&& (userInfo.Nick || userInfo.Name || userInfo.Tel)}} 车主用户您好。
    </div>
    <div class="s4s-user-body">
      <div class="s4s-group" bind:tap="gotoCarlist">
        <span class="s4s-group-tit" style="color:#24252d;">我的爱车</span>
        <div class="s4s-group-txt s4s-user-btn">管理我的爱车
          <img src="../assets/icon/right_arr.png" class="s4s-right-arr"/>
        </div>
      </div>
      <div class="s4s-group" @click="gotoOrderList">
        <span class="s4s-group-tit" style="color:#24252d;">我的订单</span>
        <div class="s4s-group-txt s4s-user-btn">当前处理中订单
          <span style="color:#3a82ff;padding:0 5px;"> {{staticData.HandleSum || 0}} </span> 条
          <img src="../assets/icon/right_arr.png"
            mode="aspectFit" class="s4s-right-arr"/>
        </div>
      </div>
    </div>
  </div>
  <div class="s4s-copyright" style="margin-top:15px;">
    <div>本服务由<span @click="gotoMys4s" class="blue">齐车大圣</span>提供，客服电话：
      <a class="s4s-copyright-phone" href="tel://0571-26281166" >0571-26281166</a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'success2',
  data() {
    return {
      // 需要挪至store
      staticData: {},
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '支付结果'
      });
    }
    if (!this.userInfo) {
      this.$router.replace({
        path: '/login',
        query: {
          redirect: '/user',
        },
      });
    } else {
      // 需要挪至store
      this.getOrderStatic();
    }
  },
  methods: {
    gotoMys4s() {
      // _czc.push(['_trackEvent', '齐车大圣', 'current=1', 's2','','']); //eslint-disable-line
      window.location.href = 'https://mys4s.cn/#/driver?current=1';
    },
    // 我的爱车
    gotoCarlist() {
      this.$router.push({
        name: 'carList',
      });
    },
    // 订单列表
    gotoOrderList() {
      this.$router.push({
        name: 'order',
      });
    },
    // 获取订单状态
    getOrderStatic() {
      this.$request('v3/violation/order/static').then((res) => {
        if (res.code === 0) {
          this.staticData = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.s4s-page {
  background-image:url(../assets/icon/bg_user.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.s4s-user {
  /* background-image: linear-gradient(-90deg, #3A82FF 10%, #115FF8 100%); */
  border-radius: 2px;
  font-size: 14px;
}
.s4s-user-header {
  text-align: center;
  color: #fff;
  padding: 26px 0 25px;
  font-size: 18px;
}
.s4s-user-body {
  padding:  0 15px;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  background-color: #fff;
  border-radius: 2px;
}

.s4s-more {
  padding: 10px 15px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 2px;
  margin-top:10px;
}

.s4s-more-title {
  color:#24252d;
  padding:10px 0 15px;
  border-bottom: .5px solid #eaeaea;
}

.s4s-more-list {
  min-height: 6px;

}

.s4s-right-arr {
  height: 14px;
  width: 7px;
  margin-left: 10.5px;
}
.s4s-user-btn {
  color:#9c9ea8;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>

